/*
 * "Read more" for long collection intros on phones (plan-64639d150402094e, 2026-09-25).
 *
 * The owner saw a first screen of text and empty space on collection pages and read it as a page
 * still loading. Below 750px the design/garment intro (.collection-hero-desc) and the team-store
 * "Who we are" block (.ts-who-body) are clamped to a few lines by collection-read-more.css, and
 * this adds the toggle. The FULL TEXT STAYS IN THE DOM: the clamp is max-height + overflow, so
 * crawlers and screen readers still get every word, and focus moving onto a hidden link expands
 * the block rather than landing on something invisible.
 *
 * The clamp CSS only applies once <html> carries .rm-on, which the templates set inline right
 * before the intro so the text is clamped on first paint instead of jumping after load. A block
 * that turns out NOT to overflow gets .rm-short, which releases the clamp and keeps the button
 * hidden, so short text is never faded or cut.
 */
(function () {
  var SELECTOR = '.collection-hero-desc, .ts-who-body';
  var mq = window.matchMedia('(max-width: 749px)');
  var seq = 0;

  function set(el, open) {
    el.classList.toggle('rm-open', open);
    el._rmBtn.setAttribute('aria-expanded', String(open));
    el._rmBtn.textContent = open ? 'Read less' : 'Read more';
  }

  function setup(el) {
    if (el._rmBtn) return;
    if (!el.id) el.id = 'rm-body-' + ++seq;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rm-toggle';
    btn.setAttribute('aria-controls', el.id);
    btn.hidden = true;
    el._rmBtn = btn;
    set(el, false);
    btn.addEventListener('click', function () { set(el, !el.classList.contains('rm-open')); });
    el.addEventListener('focusin', function () { if (!el.classList.contains('rm-open')) set(el, true); });
    el.insertAdjacentElement('afterend', btn);
  }

  function measure() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      setup(el);
      if (!mq.matches) {
        el._rmBtn.hidden = true;
        el.classList.remove('rm-clamped', 'rm-short');
        return;
      }
      if (el.classList.contains('rm-open')) { el._rmBtn.hidden = false; return; }
      el.classList.remove('rm-short');
      var over = el.scrollHeight > el.clientHeight + 2;
      el.classList.toggle('rm-clamped', over);
      el.classList.toggle('rm-short', !over);
      el._rmBtn.hidden = !over;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure);
  else measure();
  window.addEventListener('load', measure);
  if (mq.addEventListener) mq.addEventListener('change', measure);
  else if (mq.addListener) mq.addListener(measure);
})();
